import { SalesStatistic } from "../../../models/Statistics";

export const REQUEST_RECEIPTSTATISTICS = "REQUEST_RECEIPTSTATISTICS";
export const REQUEST_RECEIPTSTATISTICS_DONE = "REQUEST_RECEIPTSTATISTICS_DONE";

export interface FetchReceiptStatistics {
  type: typeof REQUEST_RECEIPTSTATISTICS;
  payload: ReadonlyArray<SalesStatistic>;
}

export interface FetchReceiptStatisticsDone {
  type: typeof REQUEST_RECEIPTSTATISTICS_DONE;
  payload: ReadonlyArray<SalesStatistic>;
}

export interface ReceiptsStatisticsState {
  isLoading: boolean;
  receiptStatistics: ReadonlyArray<SalesStatistic>;
}

export type AverageReceiptStatisticsActions =
  | FetchReceiptStatistics
  | FetchReceiptStatisticsDone;
